(() => {
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('jz-motion-ready');

  const selector = [
    '.jz-mobile-card',
    '.jz-mobile-editorial__card',
    '.jz-mobile-story > *',
    '.ui-test-product-list .product-card',
    '.template-product .product-information [class*="product-details"] > *',
    '.jz-service-card',
    '.jz-footer-panel > *'
  ].join(',');

  let observer;
  if (!reduced && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });
  }

  const hydrate = (scope = document) => {
    const items = [];
    if (scope.matches?.(selector)) items.push(scope);
    items.push(...scope.querySelectorAll?.(selector) || []);

    items.forEach((item, index) => {
      if (item.hasAttribute('data-jz-reveal')) return;
      item.setAttribute('data-jz-reveal', '');
      item.style.setProperty('--jz-delay', `${Math.min(index % 4, 3) * 55}ms`);
      if (reduced || !observer) item.classList.add('is-visible');
      else observer.observe(item);
    });
  };

  hydrate();
  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
})();
